import * as React from 'react';

// material-ui
import { Typography, IconButton, Stack, Box, Menu, MenuItem } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { DashOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router';

// project import
import { useAuth } from 'services/hook/Auth'
import { useEventBusContext } from 'services/provider/EventBusProvider'
import CellRenderer from 'components/list/CellRenderer';
import { getActionItems } from 'utils/util';
import { EVENT_ORDER_DETAIL_INIT } from '../../../models/events/order.event';
import DirhamIcon from '../../../assets/images/dirham-symbol.png'

/**
 * Render email column cell
 */
export const CellDepartment = (props) => {
    return (
        <Typography variant="body">{props.row.department != null ? props.row.department.name : ''}</Typography>
    )
}

/**
 * Render overall detail cell.
 */
export const CellMobileDetails = ({ item, propsDetails }) => {
    const labelsx = { mr: '5px', fontWeight: 'bold' }
    const statcolor = item.status == 'Blocked' ? 'red' : 'green';
    const actions = propsDetails?.actions;
    const formatCurrency = (amount) => {
        if (amount === null || amount === undefined) return '—';

        return (
            <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <img src={DirhamIcon} width={16} alt="AED" />
                {parseFloat(amount).toFixed(0)}
            </span>
        );
    };
    return (
        <Stack direction='row' sx={{ p: '6px!important', width: '100%' }}>
            <Stack direction='column' sx={{ width: '90%' }}>
                <Stack direction='row'>
                    <Typography variant="body" sx={labelsx}>{`Order #: `}</Typography>
                    <CellRenderer type="order_number" item={item} />
                </Stack>
                <Box>
                    <Typography variant="body" sx={labelsx}>{`Customer: `}</Typography>
                    <Typography variant="body">{item.customer?.name ?? '-'}</Typography>
                </Box>
                <Stack direction='row'>
                    <Typography variant="body" sx={labelsx}>{`Whatsapp: `}</Typography>
                    <Typography variant="body">{item.customer?.whatsapp_number ?? '-'}</Typography>
                </Stack>
                 <Stack direction='row'>
                    <Typography variant="body" sx={labelsx}>{`Total: `}</Typography>
                    <Typography variant="body">{formatCurrency(item.total) ?? '-'}</Typography>
                </Stack>
                <Stack direction='row'>
                    <Typography variant="body" sx={labelsx}>{`Status: `}</Typography>
                    <Typography variant="body" sx={{ ...labelsx, color: statcolor }} >{item.status}</Typography>
                </Stack>
            </Stack>
            <Box sx={{ width: '10%' }}>
                <CellMobileActions item={item} actions={actions} eventDetail={EVENT_ORDER_DETAIL_INIT} />
            </Box>
        </Stack>
    )
}

/**
 * Generic reusable menu action item
 */
const ActionMenuItem = ({ title, icon, event, payload, link, onClick, onClose }) => {
    const theme = useTheme();
    const eventbus = useEventBusContext();
    const navigate = useNavigate();
    const menuitemsx = { display: 'flex', alignItems: 'center', minHeight: 'auto', p: '8px 16px', '& .anticon': { color: theme.palette.primary.main, mr: '10px' } }

    const handleClick = (e) => {
        e.stopPropagation();

        if (onClick) {
            onClick(e, payload);
        } else if (link) {
            navigate(link);
        } else {
            eventbus.fire(event, payload);
        }

        if (onClose) {
            onClose();
        }
    };

    return (
        <MenuItem sx={menuitemsx} onClick={handleClick} >
            {icon} {title}
        </MenuItem>
    );
};

/**
 * Render action menu dropdown with permission-based controls
 */
export const CellMobileActions = ({ item, actions }) => {
    const actionitems = getActionItems(item, actions);
    const { checkPermission } = useAuth();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <Stack direction="row" justifyContent="end">
            <IconButton id="long-button" onClick={handleClick} sx={{ color: '#000', transform: 'rotate(90deg)' }} >
                <DashOutlined />
            </IconButton>

            <Menu id="long-menu" anchorEl={anchorEl} open={open} onClose={handleClose}
                slotProps={{
                    paper: {
                        style: { maxHeight: 48 * 4.5, width: '16ch' },
                    },
                }}
            >
                {actionitems.map((action, idx) =>
                    checkPermission(action.permission) && (
                        <ActionMenuItem key={idx} title={action.menu} icon={action.icon} event={action.event} payload={action.payload} link={action.link} onClose={handleClose} />
                    )
                )}
            </Menu>
        </Stack>
    );
};